import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme:{
    themes: {
      light: {
        primary: '#ffa12e',
        secondary: '#1076ff',
        accent: '#ff4f42',
        error: '#b71c1c',
      },
      dark: {
        primary: '#ffa12e',
        secondary: '#1076ff',
        accent: '#ff4f42',
        error: '#b71c1c',
      },
    },
  },
});
